import React from 'react';
import { useTranslation } from 'react-i18next';
import IFacebookShareButton from './interfaces/IFacebookShareButton';

import { ReactComponent as FacebookIconSmall } from '../assets/icons/scoreboard-fb-share.svg';

const FacebookShareButton = ({
  id, link, short,
}: IFacebookShareButton) => {
  const [translate] = useTranslation();

  if (!link) return null;

  const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;
  const linkTitle = translate('COMMON.SHARE_ON_FACEBOOK');

  const buttonId = `facebook-share-${id}`;
  const buttonStyles = `${short ? '' : 'btn btn-primary'} btn-facebook
    fb-xfbml-parse-ignore d-flex align-items-center justify-content-center`;
  const buttonLabel = short
    ? <FacebookIconSmall />
    : (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          color="#ffffff"
          height={20}
          width={20}
          className="mx-2"
        >
          <path
            fill="#ffffff"
            fillRule="evenodd"
            d="M8 14H3.667C2.733 13.9 2 13.167 2 12.233V3.667A1.65 1.65 0 0 1
              3.667 2h8.666A1.65 1.65 0 0 1 14 3.667v8.566c0 .934-.733
              1.667-1.667
              1.767H10v-3.967h1.3l.7-2.066h-2V6.933c0-.466.167-.9.867-.9H12v-1.8c.033
              0-.933-.266-1.533-.266-1.267 0-2.434.7-2.467
              2.133v1.867H6v2.066h2V14z"
          />
        </svg>
        <span>{translate('COMMON.SHARE_ON_FACEBOOK')}</span>
      </>
    );

  return (
    <a
      id={buttonId}
      href={facebookLink}
      target="_blank"
      rel="noopener noreferrer"
      title={linkTitle}
      className={buttonStyles}
    >
      {buttonLabel}
    </a>
  );
};

export default FacebookShareButton;
